/* 
    Author: Piyush Dubey
    Requirement: Warning Dialog Box
    Brief: Resuable custom warning Dialog box.
    propsTypes: {
        leftIconText: String,           // material-icon name
	    rightIconText: String,          // material-icon name
        warningText: String,
		onRequestClose: callBackFunction()
    }
*/

import React from "react";
import PropTypes from "prop-types";

const iconStyle = {
    fontSize: "18px",
    cursor: "pointer"
};

export default class CustomWarningDialog extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        leftIconText: "warning",
        rightIconText: "clear"
    };

    _closeDialog() {
        // call back to parent
        this.props.onRequestClose();
    }

    render() {
        const { leftIconText, rightIconText, warningText } = this.props;

        return (
            <div className="warningAlertBox">
                <div className="warningAlertBoxContent">
                    <span className="leftIcon">
                        <i className="material-icons" style={iconStyle}>
                            {leftIconText}
                        </i>
                    </span>
                    <span className="warningText">{warningText}</span>
                    <span className="rightIcon">
                        <i
                            className="material-icons"
                            style={iconStyle}
                            onClick={() => this._closeDialog()}
                        >
                            {rightIconText}
                        </i>
                    </span>
                </div>
            </div>
        );
    }
}

CustomWarningDialog.propTypes = {
    leftIconText: PropTypes.string,
    warningText: PropTypes.string,
    rightIconText: PropTypes.string,
    onRequestClose: PropTypes.func
};
